import { ClockCircleOutlined } from '@ant-design/icons'
import { Badge, Flex, Tooltip } from 'antd'
import { useTheme } from 'antd-style'

import { AnnouncementStatus } from '../../enums/AnnouncementStatus'

import { AnnouncementListStatusRenderProps } from './interface'

export const AnnouncementListStatusRender = ({
  record: { status, timingPublishTime, publishTime }
}: AnnouncementListStatusRenderProps) => {
  const theme = useTheme()

  if (Number(status) === AnnouncementStatus.SAVED) {
    return <Badge status='default' text='已保存' />
  }

  if (Number(status) === AnnouncementStatus.WAIT_PUBLISH) {
    return (
      <Flex vertical align='center'>
        <Badge status='warning' text='待发布' />
        <Flex align='center' gap={4} style={{ color: theme.colorWarning }}>
          <ClockCircleOutlined />
          <span>{timingPublishTime}</span>
        </Flex>
      </Flex>
    )
  }

  if (Number(status) === AnnouncementStatus.PUBLISHED) {
    return (
      <Tooltip title={publishTime}>
        {/* Tooltip 下面直接使用 Badge 会报错：findDOMNode is deprecated and will be removed in the next major release  */}
        <span>
          <Badge status='success' text='已发布' />
        </span>
      </Tooltip>
    )
  }
}
